import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { BaseApiService } from './api-base.service';
import { HelperService } from './helper.service';
import {
  AdhocClientsResponse,
  ActivitiesResponse,
  CarersResponse,
  FundingPreviewResponse,
  AdhocServiceRequest,
  AdhocServiceResponse,
  CommonActivitiesResponse,
  AdhocCommonActivitiesResponse,
  ClientAdhocSummariesResponse,
  ClientAdhocDetailResponse
} from '../models/adhoc-service.model';

@Injectable({
  providedIn: 'root'
})
export class AdhocServiceService extends BaseApiService {
  private env: string;

  constructor(
    http: HttpClient,
    msalService: MsalService,
    private helperService: HelperService
  ) {
    super(http, msalService);
    this.env = this.helperService.getStoredValue('ecase_env', 'prod');
  }

  getClients(): Observable<AdhocClientsResponse> {
    return this.get<AdhocClientsResponse>(`${this.apiUrl}/ecase/${this.env}/clients/`);
  }

  getActivities(): Observable<ActivitiesResponse> {
    return this.get<ActivitiesResponse>(`${this.apiUrl}/ecase/${this.env}/activities/`);
  }

  getCarers(): Observable<CarersResponse> {
    return this.get<CarersResponse>(`${this.apiUrl}/ecase/${this.env}/carers/`);
  }

  getCommonActivities(): Observable<CommonActivitiesResponse> {
    return this.get<CommonActivitiesResponse>(`${this.apiUrl}/ecase/${this.env}/common-activities/`);
  }

  getFundingPreview(clientId: number): Observable<FundingPreviewResponse> {
    return this.get<FundingPreviewResponse>(`${this.apiUrl}/ecase/${this.env}/adhoc-service/funding-preview/?client_id=${clientId}`);
  }

  createAdhocService(request: AdhocServiceRequest): Observable<AdhocServiceResponse> {
    return this.post<AdhocServiceResponse>(`${this.apiUrl}/ecase/${this.env}/adhoc-service/`, request);
  }

  getTimeline(date: string): Observable<any> {
    return this.get<any>(`${this.apiUrl}/ecase/${this.env}/timeline/?start_date=${date}`);
  }

  getAdhocCommonActivities(): Observable<AdhocCommonActivitiesResponse> {
    return this.get<AdhocCommonActivitiesResponse>(`${this.apiUrl}/ecase/${this.env}/adhoc-services/common-activities/`);
  }

  getClientAdhocSummaries(): Observable<ClientAdhocSummariesResponse> {
    return this.get<ClientAdhocSummariesResponse>(`${this.apiUrl}/ecase/${this.env}/adhoc-services/common-activities/by-client/`);
  }

  getClientAdhocDetail(residentId: number): Observable<ClientAdhocDetailResponse> {
    return this.get<ClientAdhocDetailResponse>(`${this.apiUrl}/ecase/${this.env}/adhoc-services/common-activities/by-client/${residentId}/`);
  }
}
